import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';

const ClickableBox = styled(Box)`
  cursor: pointer;
`;

// query selectors return a nodeList that is similar but subtly different to an array
const nodeListToArray = (nodeList) => [...nodeList];

const ExpandedClickableArea = ({ children, ...props }) => {
  const clickableElemTypes = ['a', 'button', 'input'];
  const refExpandedArea = useRef();

  const handleClick = (e) => {
    const clickedElement = e.target;
    const expandableTargets = nodeListToArray(refExpandedArea.current.querySelectorAll('[data-expanded-clickable-area-target]'));

    if (expandableTargets.length !== 1) {
      throw new Error(`Expected one clickable element but found ${expandableTargets.length}`);
    }

    const expandableTarget = expandableTargets[0];
    const targetIsClickable = clickableElemTypes.includes(clickedElement.tagName.toLowerCase());
    const isWithinClickable = clickedElement.closest(clickableElemTypes.join(', '));
    if (!isWithinClickable && expandableTarget !== clickedElement && !targetIsClickable) {
      expandableTarget.click();
    }
  };

  return (
    <ClickableBox ref={refExpandedArea} onClick={handleClick} {...props}>
      {children}
    </ClickableBox>
  );
};

ExpandedClickableArea.propTypes = {
  children: PropTypes.node,
};

ExpandedClickableArea.defaultProps = {
  children: null,
};

export default ExpandedClickableArea;
